var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid event-nav"},[_c('img',{staticStyle:{"width":"128px"},attrs:{"src":_vm.logo}})])}
var staticRenderFns = []

export { render, staticRenderFns }